import React, { useContext } from "react";
import {ThemeContext} from "../ApplicationFrame/Theme";

export default () => useContext(ThemeContext);